// components/dialogs/ImageDialog.tsx
import { Dialog, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  open: boolean;
  src: string | null;
  onClose: () => void;
};

const CommentsImageDialog = ({ open, src, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      sx={{ backgroundColor: "rgba(0,0,0,0.95)" }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          color: "white",
          backgroundColor: "rgba(0,0,0,0.5)",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
          zIndex: 10,
        }}
      >
        <CloseIcon fontSize="large" />
      </IconButton>

      {src && (
        <Box
          component="img"
          src={src}
          alt={src}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: 0,
          }}
        />
      )}
    </Dialog>
  );
};

export default CommentsImageDialog;
